export default __webpack_public_path__ + "static/media/identity-fraud@2x.6f455e62.jpg";